// Hero Scroller
export default function smoothScroll() {
    const scroller = document.querySelector('.r-scroller');
    if (scroller) {
        scroller.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default anchor behavior

            const targetId = this.getAttribute('href').substring(1); // Get the ID from href (remove #)
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        });
    }
}
